import { useEffect, useState } from 'react';
import { emailService } from '../../services/emailService';
import type { EmailSettings } from '../../types/email';

/** The school's email settings, loaded once; `setSettings` takes what a save returns. */
export function useEmailSettings() {
  const [settings, setSettings] = useState<EmailSettings | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    emailService.getSettings()
      .then(setSettings)
      .catch((err: any) => setError(err?.message || 'Couldn’t load the email settings'));
  }, []);
  return { settings, setSettings, error };
}
